module.exports = __webpack_public_path__ + "static/media/active-from-icon.7c6a61cb.svg";